import type { ActivityContentObjectDetail, ActivityContentObjectList } from 'models';
import { usePermissions } from 'permissions';
import { Title } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { ActivityTask } from 'features/programs/feed';
import type { Activity, PeriodicityType } from 'models/activity';
import { useReloadContentObjectMutation } from '../../../queries';

type P = {
  item: ActivityContentObjectDetail | ActivityContentObjectList;
  showReadMore?: boolean;
};

/** @deprecated It has also old program logic  */
const ActivityContentObjectBody = ({ item }: P) => {
  const { activity, id, program, programsTopic } = item;
  const { mutateAsync: reloadActivity } = useReloadContentObjectMutation();
  const { canDownloadProgramReport, hasJoinedProgram } = usePermissions();

  const canSubmitActivityData = !activity.isWithings;

  const activityData: Activity = {
    ...activity,
    description: activity.description ?? '',
    htmlDescription: activity.htmlDescription ?? '',
    nextPeriodDate: activity.nextPeriodDate ?? null,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- ContentObjectActivity's periodicityType isn't narrowed to the BE enum
    periodicityType: activity.periodicityType as PeriodicityType,
    programsTopicId: programsTopic.id,
    times: activity.times ?? [],
  };

  const task = (
    <ActivityTask
      activity={activityData}
      canDownloadReport={canDownloadProgramReport({ program })}
      canSubmitData={canSubmitActivityData}
      isProgramPublished={program.status === 'published'}
      onSuccess={async () => {
        await reloadActivity({ filter: { id } });
      }}
      reloadingPost={false}
      userSubscribed={hasJoinedProgram({ program })}
    />
  );

  return (
    <>
      <Title level={5}>{activity.name}</Title>
      {task}
    </>
  );
};

export default ActivityContentObjectBody;
